<template>
  <div>
    <appHeader></appHeader>
    <div class="container-fluid account p-4">

      <!-- Stepper -->
      <div class="cart-stepper mb-4">
        <div class="cs-step done">
          <div class="cs-dot"><font-awesome-icon icon="check" /></div>
          <span>Choose item</span>
        </div>
        <div class="cs-line cs-line-done"></div>
        <div class="cs-step done">
          <div class="cs-dot"><font-awesome-icon icon="check" /></div>
          <span>Shipping information</span>
        </div>
        <div class="cs-line cs-line-done"></div>
        <div class="cs-step done">
          <div class="cs-dot"><font-awesome-icon icon="check" /></div>
          <span>Order summary</span>
        </div>
      </div>

      <!-- Loading -->
      <transition v-if="isOrderingInProgress" appear name="fade">
        <div class="bos-loading">
          <div class="spinner-border text-primary" role="status">
            <span class="sr-only">Setting up your order...</span>
          </div>
          <p class="bos-loading-text">Processing your order...</p>
        </div>
      </transition>

      <transition v-else appear name="fade">
        <div class="row d-flex justify-content-center">
          <div class="col-lg-10 col-md-12 mx-auto">

            <!-- Success banner -->
            <div class="bos-banner mb-4">
              <div class="bos-banner-icon">
                <font-awesome-icon icon="check" />
              </div>
              <div>
                <div class="bos-banner-title">
                  {{ userName }}, your order was successfully submitted
                </div>
                <div class="bos-banner-sub">
                  A confirmation has been sent to your email address.
                </div>
              </div>
            </div>

            <!-- Items being processed -->
            <div v-if="productsProcessing.length > 0" class="bos-section mb-4">
              <div class="bos-section-header">
                <font-awesome-icon icon="clock" class="mr-1" />
                <span>Items being processed</span>
                <span class="bos-count-badge">{{ productsProcessing.length }}</span>
              </div>

              <div
                v-for="product in productsProcessing"
                :key="product.id"
                class="bos-product-row"
              >
                <router-link
                  :to="{ name: 'Bonus Product', params: { productId: product.productId } }"
                  class="bos-prod-img"
                >
                  <img :alt="product.name" :src="product.imageUrl" />
                </router-link>

                <div class="bos-prod-body">
                  <router-link
                    :to="{ name: 'Bonus Product', params: { productId: product.productId } }"
                    class="bos-prod-name"
                  >{{ product.name }}</router-link>

                  <div v-if="product.isCard" class="bos-processing-note">
                    This card will be sent to your email. Please check within two business days.
                  </div>
                  <div v-else class="bos-processing-note">
                    {{ product.description }}
                  </div>
                  <div v-if="!product.isCard" class="bos-delivery-note">
                    Please allow up to <strong>4 weeks for delivery.</strong>
                  </div>

                  <div class="bos-meta-row">
                    <span class="bos-chip">Qty: {{ product.quantity | numToLocale }}</span>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </transition>

      <!-- Continue shopping -->
      <div class="bos-continue-wrap">
        <router-link class="bos-continue-btn" to="/shop">
          <font-awesome-icon icon="cart-plus" class="mr-2" />
          Continue shopping
        </router-link>
      </div>

    </div>

    <!-- Help section -->
    <transition appear name="fade">
      <div class="bos-help-section">
        <div class="os-help-section">
          <div class="os-help-title">What's next?</div>
          <div class="os-tips-list">
            <div class="os-tip-card">
              <div class="os-tip-icon"><font-awesome-icon icon="rocket" /></div>
              <div>Multiple items may ship separately with different tracking numbers.</div>
            </div>
            <div class="os-tip-card">
              <div class="os-tip-icon"><font-awesome-icon icon="rocket" /></div>
              <div>If you don't see your gift card, <strong>check your spam folder.</strong></div>
            </div>
          </div>
          <div class="os-contact-card">
            <strong>Need Help?</strong><br />
            <ul>
              <li>Check the “Customer Service/Tracking” tab for tracking numbers.</li>
              <li>If you do not receive your gift card email(s) within 24 hours, or need further assistance, please contact us at support@divvyengagement.com</li>
            </ul>
          </div>
        </div>
      </div>
    </transition>

    <appFooter></appFooter>
  </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import { mapState } from 'vuex'

export default {
  components: {
    appHeader: Header,
    appFooter: Footer
  },
  data () {
    return {
      checkoutProgressMax: 100,
      checkoutProgressCurrent: 100,

      isOrderingInProgress: true,

      productsProcessing: [],
    }
  },
  computed: {
    ...mapState({
      bonusPointsMenuItem: state => state.company.bonusPointsMenuItem,
      bonusPointsDetails: state => state.product.bonusPointsDetails,

      bonusPointsChosenVersion: state => state.product.bonusPointsChosenVersion,

      userName: state => state.user.profile.firstName,
    }),
  },
  methods: {
    addPhysicalProduct (targetArray, physicalProduct) {
      let newProduct = {
        orderNumber: physicalProduct.orderNumber,
        name: physicalProduct.name,
        productId: physicalProduct.productId,
        imageUrl: physicalProduct.imageUrl,
        quantity: physicalProduct.quantity,
        points: physicalProduct.points,
        currency: 'pts',
        isCard: false,
      }
      targetArray.push(newProduct)
    },
    showSuccess: function (message, onClose) {
      this.$bvModal.msgBoxOk(message, {
        size: 'sm',
        headerClass: 'p-2 border-bottom-0',
        footerClass: 'p-2 border-top-0',
        centered: true
      })
          .then(() => {
            onClose()
          })
    },
    showError: function (message) {
      this.$bvModal.msgBoxOk(message, {
        size: 'sm',
        headerClass: 'p-2 border-bottom-0',
        footerClass: 'p-2 border-top-0',
        okVariant: 'danger',
        centered: true
      })
    }
  },
  created () {
    this.$store.dispatch('user/orderBonus', {
      productId: this.bonusPointsChosenVersion.productId,
      productVersionId: this.bonusPointsChosenVersion.productVersionId,
    })
        .then((response) => {
          this.isOrderingInProgress = false
          if (response.isRequestValid) {
            response.physicalProducts.forEach(element => {
                  this.addPhysicalProduct(this.productsProcessing, element)
                }
            )
          } else {
            // TODO have some specific UI to tell this to the user (not just a modal)
            this.showError(response.errorsArray.join('\n'))
          }
        })
        .catch(() => {
          this.showError('Failed to order cart contents')
        })
  },
}
</script>

<style lang="scss">

/* ── Stepper ── */
.cart-stepper { display: flex; align-items: center; }
.cs-step { display: flex; align-items: center; gap: 7px; font-size: 13px; color: $gray-500; }
.cs-step.done { color: $success; font-weight: 500; }
.cs-dot {
  width: 22px; height: 22px; border-radius: 50%;
  border: 2px solid $gray-300;
  display: flex; align-items: center; justify-content: center;
  font-size: 9px; font-weight: 500; background: #fff; color: $gray-500; flex-shrink: 0;
}
.cs-step.done .cs-dot { border-color: $success; color: #fff; background: $success; }
.cs-line { flex: 1; height: 1px; background: $gray-200; min-width: 20px; }
.cs-line-done { background: $success; }

/* ── Loading ── */
.bos-loading {
  display: flex; flex-direction: column; align-items: center;
  justify-content: center; padding: 4rem 0; gap: 1rem;
}
.bos-loading-text { font-size: 14px; color: $gray-600; margin: 0; }

/* ── Success banner ── */
.bos-banner {
  display: flex; align-items: center; gap: 14px;
  background: #f0faf4; border: 1px solid #c3e6cb;
  border-radius: $border-radius; padding: 1rem 1.25rem;
}
.bos-banner-icon {
  width: 36px; height: 36px; border-radius: 50%;
  background: $success; color: #fff;
  display: flex; align-items: center; justify-content: center;
  font-size: 14px; flex-shrink: 0;
}
.bos-banner-title { font-size: 15px; font-weight: 500; color: #1b5e20; }
.bos-banner-sub   { font-size: 13px; color: #388e3c; margin-top: 2px; }

/* ── Section card ── */
.bos-section {
  background: #fff; border: 1px solid $gray-200;
  border-radius: $border-radius; overflow: hidden;
}
.bos-section-header {
  display: flex; align-items: center; gap: 8px;
  padding: .75rem 1rem; font-size: 13px; font-weight: 500;
  color: $gray-700; background: $gray-100;
  border-bottom: 1px solid $gray-200;
}
.bos-count-badge {
  display: inline-flex; align-items: center; justify-content: center;
  width: 20px; height: 20px; border-radius: 50%;
  background: $gray-300; color: $gray-700;
  font-size: 11px; font-weight: 500; margin-left: auto;
}

/* ── Product row ── */
.bos-product-row {
  display: flex; gap: 1rem; align-items: flex-start;
  padding: 1rem; border-bottom: 1px solid $gray-100;
  &:last-child { border-bottom: none; }
}
.bos-prod-img {
  display: block; width: 80px; min-width: 80px; height: 80px;
  border-radius: $border-radius-sm; overflow: hidden;
  background: $gray-100; border: 1px solid $gray-200; flex-shrink: 0;
  img {
    width: 100%; height: 100%;
    object-fit: contain; object-position: center; padding: 4px;
  }
}
.bos-prod-body { flex: 1; min-width: 0; display: flex; flex-direction: column; gap: 5px; }
.bos-prod-name {
  font-size: 14px; font-weight: 500; color: $gray-900;
  text-decoration: none; line-height: 1.4;
  &:hover { color: $primary; text-decoration: none; }
}
.bos-processing-note { font-size: 12.5px; color: $gray-600; line-height: 1.5; }
.bos-delivery-note   { font-size: 12px; color: $gray-500; }

/* ── Meta chips ── */
.bos-meta-row { display: flex; flex-wrap: wrap; gap: 6px; margin-top: 4px; }
.bos-chip {
  display: inline-flex; align-items: center;
  background: $gray-100; border: 1px solid $gray-200;
  border-radius: $border-radius-sm; padding: 2px 10px;
  font-size: 12px; color: $gray-600;
}

/* ── Continue button ── */
.bos-continue-wrap { display: flex; justify-content: center; padding: 1rem 0; }
.bos-continue-btn {
  display: inline-flex; align-items: center; gap: 8px;
  background: $primary; color: #fff; border: none;
  border-radius: $border-radius-sm; padding: 10px 24px;
  font-size: 14px; font-weight: 500; text-decoration: none;
  transition: background .15s ease;
  &:hover { background: darken($primary, 8%); color: #fff; text-decoration: none; }
}

/* ── Help section ── */
.bos-help-section {
  background: $gray-100; border-top: 1px solid $gray-200;
}
.bos-help-inner {
  max-width: 960px; margin: 0 auto; padding: 1.5rem 1.25rem;
}
.bos-help-title { font-size: 15px; font-weight: 500; margin-bottom: 1rem; }
.bos-tips-grid {
  display: grid; grid-template-columns: 1fr 1fr;
  gap: .75rem; margin-bottom: 1rem;
}
.bos-tip-card {
  display: flex; align-items: flex-start; gap: 10px;
  background: #fff; border: 1px solid $gray-200;
  border-radius: $border-radius-sm; padding: .75rem;
  font-size: 12.5px; color: $gray-600; line-height: 1.5;
  a { color: $primary; }
}
.bos-tip-icon {
  width: 28px; height: 28px; border-radius: 50%;
  background: $gray-600; color: #fff; font-size: 11px;
  display: flex; align-items: center; justify-content: center;
  flex-shrink: 0; margin-top: 1px;
}
.bos-contact-card {
  background: #fff; border: 1px solid $gray-200;
  border-radius: $border-radius-sm; padding: .85rem 1rem;
  font-size: 13px; color: $gray-600; line-height: 1.7;
  a { color: $primary; }
}

/* ── Responsive ── */
@media (max-width: 576px) {
  .bos-tips-grid { grid-template-columns: 1fr; }
  .bos-prod-img { width: 64px; min-width: 64px; height: 64px; }
  .bos-product-row { padding: .85rem; gap: .75rem; }
}

h3::after, h4::after, h5::after { display: none; }
.modal-body { padding: 2rem 2rem 0 2rem !important; }

/* ── Help section ── */
.os-help-section {
  background: $gray-100; border-radius: $border-radius;
  padding: 1.25rem; margin-top: .5rem; margin-bottom: 1.5rem;
}
.os-help-title { font-size: 14px; font-weight: 500; margin-bottom: .85rem; }
.os-tips-grid {
  display: grid; grid-template-columns: 1fr 1fr;
  gap: .75rem; margin-bottom: 1rem;
}
.os-tips-list { display: flex; flex-direction: column; gap: .6rem; margin-bottom: .85rem; }
.os-tip-card {
  display: flex; align-items: flex-start; gap: 10px;
  background: #fff; border: 1px solid $gray-200;
  border-radius: $border-radius-sm; padding: .75rem;
  font-size: 12.5px; color: $gray-600; line-height: 1.5;
}
.os-tip-icon {
  width: 28px; height: 28px; border-radius: 50%; background: $gray-600;
  display: flex; align-items: center; justify-content: center;
  color: #fff; font-size: 11px; flex-shrink: 0; margin-top: 1px;
}
.os-contact-card {
  background: #fff; border: 1px solid $gray-200;
  border-radius: $border-radius-sm; padding: .85rem 1rem;
  font-size: 13px; color: $gray-600; line-height: 1.7;
  a { color: $primary; }
}

/* ── Instructions collapse ── */
.instructions { background: #fff !important; font-size: 13px; }

/* ── Responsive ── */
@media (max-width: 576px) {
  .os-tips-grid { grid-template-columns: 1fr; }
  .os-prod-img { width: 64px; min-width: 64px; height: 64px; }
  .os-product-row { padding: .85rem; gap: .75rem; }
}
</style>